import fp from 'lodash/fp'
import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { spec, validators, toValidatorWithArgs } from 'utils/validation'

import EditMakeInwinFormComponent from './component'
import { listSponsors, listTriggers, listBeneficiary } from './helpers'

const { any, string } = validators

const validateSponsorMaxValue = toValidatorWithArgs(
  validators.custom.AMOUNT_MORE_THAN_MAXIMUM,
  (propToCheck, value, { context }) => {
    const propValue = fp.get(`current.${propToCheck}`, context)
    // when sponsors not provided
    if (!context.current?.sponsors) {
      return true
    }
    return Number(value) <= Number(propValue.limit)
  }
)

const validateBetMinValue = toValidatorWithArgs(
  validators.custom.AMOUNT_MORE_THAN_MIN_BET,
  (propToCheck, value, { context }) => {
    const propValue = fp.get(`current.${propToCheck}`, context)
    return Number(propValue) > 0
  }
)

export const EditMakeInwinForm = combine(
  withContext(
    'sponsorsService',
    ServicesContext,
    ({ sponsorsService }) => sponsorsService
  ),
  withContext(
    'memberService',
    ServicesContext,
    ({ memberService }) => memberService
  ),
  withContext(
    'triggerService',
    ServicesContext,
    ({ triggerService }) => triggerService
  ),
  withFormModel(
    () => {
      return {
        beneficiary: {
          initialValue: '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        amount: {
          initialValue: '',
          spec: spec.flow(
            validateBetMinValue('amount'),
            string.isNotEmpty,
            any.required
          ),
        },

        totalAmount: {
          initialValue: '',
          spec: spec.flow(any.required),
        },

        triggers: {
          initialValue: '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        sponsors: {
          initialValue: 0,
          spec: spec.flow(),
        },

        sponsorAmount: {
          initialValue: 0,
          spec: spec.flow(validateSponsorMaxValue('sponsors')),
        },
      }
    },
    { id: 'make-inwin-form' }
  ),

  withCallbacks(
    {
      loadSponsors: (params) => async (SponsorName) => {
        const content = await params.sponsorsService.getListOfSponsors({
          fullName: SponsorName,
        })
        return listSponsors(content.content)
      },

      loadBeneficiaries: (params) => async (beneficiaryName) => {
        const content = await params.memberService.queryBeneficiaries({
          beneficiaryName: beneficiaryName,
        })
        return listBeneficiary(content.content)
      },

      loadTriggers:
        (params, { initialValues }) =>
        async () => {
          const content = await params.triggerService.queryEventTriggers(
            initialValues.eventId
          )
          return listTriggers(content.content)
        },

      onSubmitRequest: {
        deps: ['onSubmit'],
        func:
          (_state, { onSubmit }) =>
          (form) => {
            return onSubmit(form)
          },
      },
    },
    []
  )
)(EditMakeInwinFormComponent)
